/* Okholm Studio – Black Month VIP 2026 landingsside
   Scroll-reveal, blød scroll til formularen, Klaviyo-tilmelding (Client API, uden embed-form),
   nedtælling, sticky CTA på mobil. Ingen eksterne biblioteker. Respekterer prefers-reduced-motion. */
(function () {
  if (window.VipLanding) return;
  window.VipLanding = true;

  var doc = document;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var STORAGE_KEY = 'okholm_vip_2026';
  var observer = null;

  function storageGet() { try { return window.localStorage.getItem(STORAGE_KEY); } catch (e) { return null; } }
  function storageSet() { try { window.localStorage.setItem(STORAGE_KEY, '1'); } catch (e) { /* privat tilstand el. blokeret */ } }

  /* ---------- Scroll-reveal ---------- */
  function show(el) { el.classList.add('is-visible'); }
  if ('IntersectionObserver' in window && !reduce && !designMode) {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { show(entry.target); observer.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  }
  function initReveal(root) {
    var nodes = (root || doc).querySelectorAll('.vip-reveal:not(.is-visible)');
    for (var i = 0; i < nodes.length; i++) {
      if (observer) observer.observe(nodes[i]); else show(nodes[i]);
    }
  }

  /* ---------- Blød scroll til #vip-signup + fokus i fornavn ---------- */
  function headerOffset() {
    var v = getComputedStyle(doc.documentElement).getPropertyValue('--header-height');
    var n = parseInt(v, 10);
    if (!isNaN(n) && n > 0 && n < 200) return n;
    var header = doc.querySelector('.header-sections');
    return header ? Math.min(header.offsetHeight, 140) : 0;
  }
  function scrollToEl(target, pushHash) {
    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 12;
    try { window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' }); } catch (e) { window.scrollTo(0, top); }
    if (pushHash && window.history && window.history.pushState) window.history.pushState(null, '', pushHash);
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    try { target.focus({ preventScroll: true }); } catch (e) { /* ældre browsere */ }
  }
  doc.addEventListener('click', function (ev) {
    var link = ev.target.closest ? ev.target.closest('[data-vip-scroll]') : null;
    if (!link) return;
    var href = link.getAttribute('href') || '';
    if (href.charAt(0) !== '#' || href.length < 2) return;
    var target = doc.getElementById(href.slice(1));
    if (!target) return;
    ev.preventDefault();
    scrollToEl(target, href);
    var first = target.querySelector('form:not([hidden]) input[name="first_name"]');
    if (first) {
      setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (e) {} }, reduce ? 0 : 650);
    }
  });

  /* ---------- Klaviyo-tilmelding ---------- */
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  function fieldError(field, msg) {
    var errId = field.getAttribute('aria-describedby');
    var err = errId ? doc.getElementById(errId.split(' ')[0]) : null;
    field.setAttribute('aria-invalid', msg ? 'true' : 'false');
    if (err) { err.textContent = msg || ''; err.classList.toggle('is-visible', !!msg); }
  }
  function utmSource() {
    try {
      var p = new URLSearchParams(window.location.search);
      var s = p.get('utm_source');
      return s ? String(s).slice(0, 80) : null;
    } catch (e) { return null; }
  }
  function showSuccess(card) {
    var form = card.querySelector('[data-vip-form]');
    var success = card.querySelector('[data-vip-success]');
    if (form) form.setAttribute('hidden', '');
    if (success) success.removeAttribute('hidden');
    doc.body.classList.add('vip-signed');
  }
  function initSignup(card) {
    if (!card || card.hasAttribute('data-vip-ready')) return;
    card.setAttribute('data-vip-ready', '');
    var form = card.querySelector('[data-vip-form]');
    if (!form) return;

    if (storageGet() === '1' && !designMode) {
      showSuccess(card);
      return;
    }

    var first = form.querySelector('input[name="first_name"]');
    var email = form.querySelector('input[name="email"]');
    var consent = form.querySelector('input[name="consent"]');
    var consentWrap = consent ? consent.closest('.vip-consent') : null;
    var btn = form.querySelector('button[type="submit"]');
    var btnLabel = btn ? btn.querySelector('span') : null;
    var msg = form.querySelector('[data-vip-msg]');
    var sending = false;

    function setMsg(text) {
      if (!msg) return;
      msg.textContent = text || '';
      msg.classList.toggle('is-visible', !!text);
    }
    function validate() {
      var ok = true;
      var firstInvalid = null;
      if (first) {
        var v = first.value.trim();
        if (!v) { fieldError(first, first.getAttribute('data-vip-msg-required') || 'Skriv dit fornavn.'); ok = false; firstInvalid = firstInvalid || first; }
        else fieldError(first, '');
      }
      if (email) {
        var ev = email.value.trim();
        if (!ev) { fieldError(email, email.getAttribute('data-vip-msg-required') || 'Skriv din e-mail.'); ok = false; firstInvalid = firstInvalid || email; }
        else if (!EMAIL_RE.test(ev)) { fieldError(email, email.getAttribute('data-vip-msg-invalid') || 'Tjek lige e-mailen – den ser ikke rigtig ud.'); ok = false; firstInvalid = firstInvalid || email; }
        else fieldError(email, '');
      }
      if (consent && !consent.checked) {
        if (consentWrap) consentWrap.classList.add('is-invalid');
        setMsg(consent.getAttribute('data-vip-msg-required') || 'Sæt flueben, så vi må sende dig din VIP-adgang.');
        ok = false;
        firstInvalid = firstInvalid || consent;
      } else if (consentWrap) {
        consentWrap.classList.remove('is-invalid');
        if (ok) setMsg('');
      }
      if (firstInvalid) { try { firstInvalid.focus({ preventScroll: true }); } catch (e) {} }
      return ok;
    }

    [first, email].forEach(function (f) {
      if (!f) return;
      f.addEventListener('input', function () { if (f.getAttribute('aria-invalid') === 'true') fieldError(f, ''); });
    });
    if (consent) consent.addEventListener('change', function () {
      if (consent.checked && consentWrap) { consentWrap.classList.remove('is-invalid'); setMsg(''); }
    });

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (sending) return;
      if (!validate()) return;

      var companyId = card.getAttribute('data-vip-company') || '';
      var listId = card.getAttribute('data-vip-list') || '';
      var revision = card.getAttribute('data-vip-revision') || '2025-07-15';
      var source = card.getAttribute('data-vip-source') || 'Black Month VIP 2026 landingsside';
      if (!companyId || !listId) { setMsg('Tilmeldingen er ikke sat op endnu – prøv igen om lidt.'); return; }

      var props = { vip_2026: true };
      var utm = utmSource();
      if (utm) props.vip_source = utm;

      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email.value.trim(),
                  first_name: first ? first.value.trim() : undefined,
                  properties: props
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: listId } } }
        }
      };

      sending = true;
      setMsg('');
      if (btn) {
        btn.setAttribute('aria-busy', 'true');
        btn.setAttribute('disabled', '');
        if (btnLabel) { btnLabel.setAttribute('data-vip-label', btnLabel.textContent); btnLabel.textContent = btn.getAttribute('data-vip-sending') || 'Et øjeblik …'; }
      }

      var done = function () {
        sending = false;
        if (btn) {
          btn.removeAttribute('aria-busy');
          btn.removeAttribute('disabled');
          if (btnLabel && btnLabel.getAttribute('data-vip-label')) btnLabel.textContent = btnLabel.getAttribute('data-vip-label');
        }
      };
      var fail = function () {
        done();
        setMsg(card.getAttribute('data-vip-msg-error') || 'Hov, det gik ikke igennem. Prøv igen om et øjeblik – eller skriv til os, hvis det bliver ved.');
      };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': revision },
        body: JSON.stringify(payload)
      }).then(function (res) {
        if (res.ok || res.status === 202) {
          done();
          storageSet();
          showSuccess(card);
          var success = card.querySelector('[data-vip-success]');
          if (success) { success.setAttribute('tabindex', '-1'); try { success.focus({ preventScroll: true }); } catch (e) {} }
          try { if (window.dataLayer) window.dataLayer.push({ event: 'vip_signup', list_id: listId }); } catch (e) {}
        } else {
          fail();
        }
      }).catch(fail);
    });
  }

  /* ---------- Nedtælling ---------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function setNum(el, value) {
    var text = pad(value);
    if (el.textContent === text) return;
    if (!reduce) {
      el.classList.add('is-tick');
      setTimeout(function () { el.textContent = text; el.classList.remove('is-tick'); }, 120);
    } else {
      el.textContent = text;
    }
  }
  function initCountdown(section) {
    if (!section || section.hasAttribute('data-vip-ready')) return;
    section.setAttribute('data-vip-ready', '');
    var open = Date.parse(section.getAttribute('data-vip-open') || '');
    var pub = Date.parse(section.getAttribute('data-vip-public') || '');
    if (isNaN(open)) return;
    var nums = {
      d: section.querySelector('[data-vip-days]'),
      h: section.querySelector('[data-vip-hours]'),
      m: section.querySelector('[data-vip-mins]'),
      s: section.querySelector('[data-vip-secs]')
    };
    var timer = null;
    function setState(name) {
      section.classList.remove('vip-count--counting', 'vip-count--open', 'vip-count--public');
      section.classList.add('vip-count--' + name);
      var states = section.querySelectorAll('[data-vip-state]');
      for (var i = 0; i < states.length; i++) {
        states[i].classList.toggle('is-active', states[i].getAttribute('data-vip-state') === name);
      }
    }
    function tick() {
      var now = Date.now();
      if (!isNaN(pub) && now >= pub) { setState('public'); if (timer) clearInterval(timer); return; }
      if (now >= open) { setState('open'); if (timer) clearInterval(timer); return; }
      setState('counting');
      var diff = Math.max(0, Math.floor((open - now) / 1000));
      var d = Math.floor(diff / 86400); diff -= d * 86400;
      var h = Math.floor(diff / 3600); diff -= h * 3600;
      var m = Math.floor(diff / 60);
      var s = diff - m * 60;
      if (nums.d) setNum(nums.d, d);
      if (nums.h) setNum(nums.h, h);
      if (nums.m) setNum(nums.m, m);
      if (nums.s) setNum(nums.s, s);
    }
    tick();
    timer = setInterval(tick, 1000);
  }

  /* ---------- Sticky CTA: skjul når formularen/hero/footer er synlig ---------- */
  function initSticky() {
    var sticky = doc.querySelector('[data-vip-sticky]');
    if (!sticky) return;
    doc.body.classList.add('vip-has-sticky');
    if (storageGet() === '1' && !designMode) { sticky.classList.add('is-hidden'); return; }
    var target = doc.getElementById(sticky.getAttribute('data-vip-sticky-target') || 'vip-signup');
    var targetVisible = false;
    var footerVisible = false;
    function update() { sticky.classList.toggle('is-hidden', targetVisible || footerVisible || doc.body.classList.contains('vip-signed')); }
    if (!('IntersectionObserver' in window)) { sticky.classList.remove('is-hidden'); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { if (entry.target === target) targetVisible = entry.isIntersecting; });
      update();
    }, { threshold: [0, 0.2] });
    if (target) io.observe(target);
    var footer = doc.querySelector('.footer-sections, .site-footer, footer');
    if (footer) {
      var io2 = new IntersectionObserver(function (entries) { footerVisible = entries[0].isIntersecting; update(); }, { threshold: 0 });
      io2.observe(footer);
    }
    update();
  }

  function init(root) {
    initReveal(root);
    var cards = (root || doc).querySelectorAll('[data-vip-signup]');
    for (var i = 0; i < cards.length; i++) initSignup(cards[i]);
    var counts = (root || doc).querySelectorAll('[data-vip-countdown]');
    for (var j = 0; j < counts.length; j++) initCountdown(counts[j]);
  }
  function ready() { init(doc); initSticky(); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', ready); else ready();
  doc.addEventListener('shopify:section:load', function (e) { init(e.target); initSticky(); });
  doc.addEventListener('shopify:section:select', function (e) { init(e.target); });
})();
